import './bootstrap';
import Vue from 'vue';
import { createInertiaApp } from '@inertiajs/vue2';
import VueCompositionAPI from '@vue/composition-api';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import { ValidationProvider } from 'vee-validate';
import './vee-validate';
import { createPinia, PiniaVuePlugin } from 'pinia';
import vuetify from './vuetify';

if (process.env.MIX_BUGSNAG_WEB_FRONTEND_KEY) {
  Bugsnag.start({
    apiKey: process.env.MIX_BUGSNAG_WEB_FRONTEND_KEY,
    plugins: [new BugsnagPluginVue()],
  });

  const bugsnagVue = Bugsnag.getPlugin('vue');
  bugsnagVue?.installVueErrorHandler(Vue);
}

createInertiaApp({
  resolve: async (name) => {
    return (await import(`./Pages/${name}`)).default;
  },
  setup({ el, App, props, plugin }) {
    Vue.use(plugin);
    Vue.use(VueCompositionAPI);
    Vue.use(Buefy);
    Vue.component('ValidationProvider', ValidationProvider);
    Vue.use(PiniaVuePlugin);
    const pinia = createPinia();

    new Vue({
      render: (h) => h(App, props),
      pinia,
      vuetify,
    }).$mount(el);
  },
});
